import isUndefined from 'lodash/isUndefined'
import mapValues from 'lodash/mapValues'

export const defaultFetchState = {
  isRequest: false,
  isSuccess: false,
  isFailure: false,
  data: null,
  error: null,
}

const ACTION_TYPES = Object.freeze({
  request: 'REQUEST',
  success: 'SUCCESS',
  failure: 'FAILURE',
})

/**
 * @param action
 * @returns {Readonly<{request: string, success: string, failure: string}>|{}}
 */
export const createAsyncActionTypes = (action) => {
  if (isUndefined(action)) {
    return ACTION_TYPES
  }

  return mapValues(ACTION_TYPES, (type) => {
    return `${action}_${type}`
  })
}
